<template>
  <div
    id="app"
    v-wechat-title="'数智文稿'"
  >
    <router-view />
    <headimg></headimg>
    <share></share>
    <sharetype></sharetype>
    <extractcode></extractcode>
    <login></login>
    <logincompany></logincompany>
    <department></department>
    <printview></printview>
    <preview-video></preview-video>
    <preview-audio></preview-audio>
    <preview-picture></preview-picture>
    <insertvideo></insertvideo>
    <insertaudio></insertaudio>
    <preview-article></preview-article>
    <batchoperate></batchoperate>
    <preview-app></preview-app>
    <watermark></watermark>
    <cropper></cropper>
    <movebox></movebox>
    <image-preview />
    <auditarticle></auditarticle>
    <savematterposition></savematterposition>
    <matterdetail></matterdetail>
    <sendpicmatter></sendpicmatter>
    <changepicinfo></changepicinfo>
    <batchmodifyinfo></batchmodifyinfo>
    <changsingleinfo></changsingleinfo>
    <uploadpic></uploadpic>
    <uploadmatter></uploadmatter>
    <relatedformmatter></relatedformmatter>
    <submitarticle></submitarticle>
    <deletewatermark></deletewatermark>
    <browserplug></browserplug>
    <adjustArticlePicture></adjustArticlePicture>
    <!-- 推送模块 -->
    <auditsure></auditsure>
    <pushservice></pushservice>
    <pusheachservice></pusheachservice>

  </div>
</template>

<script>
import headimg from './components/commons/headimg/headimg'
import share from './components/commons/share/share'
import sharetype from './components/commons/share/sharetype'
import extractcode from './components/commons/share/extractcode'
import login from './components/commons/share/login'
import logincompany from './components/commons/share/logincompany'
import department from './components/commons/member/department'
import printview from './components/commons/print/printview'
import previewVideo from './components/commons/previewfile/previewVideo'
import previewAudio from './components/commons/previewfile/previewAudio'
import previewPicture from './components/commons/previewfile/previewPicture'
import previewArticle from './components/commons/previewfile/previewArticle'
import insertvideo from './components/commons/insertvideo/insertvideo'
import insertaudio from './components/commons/insertaudio/insertaudio'
import batchoperate from './components/commons/batchoperate/batchoperate'
import previewApp from './components/commons/previewfile/previewApp'
import watermark from './components/commons/watermark/watermark'
import cropper from './components/commons/cropper/cropper'
import movebox from './components/commons/movebox/movebox'
import ImagePreview from '../src/components/systemset/commons/imagePreivew'
import auditarticle from './components/commons/auditarticle/auditarticle'
import savematterposition from './components/commons/savematterposition/savematterposition'
import matterdetail from './components/commons/matterdetail/matterdetail'
import sendpicmatter from './components/commons/sendpicmatter/sendpicmatter'
import changepicinfo from './components/commons/sendpicmatter/changepicinfo'
import batchmodifyinfo from './components/commons/sendpicmatter/batchmodifyinfo'
import changsingleinfo from './components/commons/sendpicmatter/changsingleinfo'
import uploadpic from './components/commons/uploadmaterial/uploadpic'
import uploadmatter from './components/commons/uploadmaterial/uploadmatter'
import relatedformmatter from './components/commons/uploadmaterial/relatedformmatter'
import submitarticle from './components/commons/submitarticle/submitarticle'
import deletewatermark from './components/commons/deletewatermark/deletewatermark'
import browserplug from './components/commons/browserplug/browserplug'
import adjustArticlePicture from './components/commons/adjustArticlePicture/adjustArticlePicture'
// 推送模块
import pushservice from './components/commons/push/pushservice'
import auditsure from './components/commons/push/auditsure'
import pusheachservice from './components/commons/push/pusheachservice'





export default {
  name: 'App',
  components: {
    headimg,
    share,
    sharetype,
    extractcode,
    login,
    logincompany,
    department,
    printview,
    previewVideo,
    previewAudio,
    previewPicture,
    previewArticle,
    insertvideo,
    insertaudio,
    batchoperate,
    previewApp,
    watermark,
    cropper,
    movebox,
    ImagePreview,
    auditarticle,
    savematterposition,
    matterdetail,
    sendpicmatter,
    changepicinfo,
    batchmodifyinfo,
    changsingleinfo,
    uploadpic,
    uploadmatter,
    relatedformmatter,
    submitarticle,
    deletewatermark,
    browserplug,
    adjustArticlePicture,
    //推送模块
    pushservice,
    auditsure,
    pusheachservice
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
